import logger from './logger';

const fetchExternalHtml = async ({ url }) => {
  try {
    const response = await fetch(url, {
      keepalive: true,
    });

    if (!response.ok) {
      throw new Error(`${response.statusText}`);
    }

    const html = await response.text();

    return {
      html,
    };
  } catch (error) {
    logger.error(`[fetchExternalHtml] error trying get ${url}`, error);
    return null;
  }
};

export default fetchExternalHtml;
